import React from "react";
import { Phone, MessageCircle, Menu, X } from "lucide-react";
import { CONTACTS, waLink, telLink, LOGOS } from "../lib/contact";

const navItems = [
  { label: "Serviços", href: "#servicos" },
  { label: "Diferenciais", href: "#diferenciais" },
  { label: "Áreas", href: "#areas" },
  { label: "Depoimentos", href: "#depoimentos" },
  { label: "Contato", href: "#contato" },
];

export default function Header() {
  const [open, setOpen] = React.useState(false);
  const [scrolled, setScrolled] = React.useState(false);

  React.useEffect(() => {
    const onScroll = () => setScrolled(window.scrollY > 20);
    window.addEventListener("scroll", onScroll);
    return () => window.removeEventListener("scroll", onScroll);
  }, []);

  return (
    <header
      data-testid="site-header"
      className={`fixed top-0 inset-x-0 z-40 transition-all duration-300 ${
        scrolled
          ? "bg-black/90 backdrop-blur-md border-b border-white/10"
          : "bg-gradient-to-b from-black/80 to-transparent"
      }`}
    >
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="flex items-center justify-between h-20">
          {/* Logo */}
          <a
            href="#top"
            data-testid="header-logo-link"
            className="flex items-center group"
          >
            <img
              src={LOGOS.main}
              alt="JR Auto Socorro 24h"
              className="h-14 sm:h-16 w-auto object-contain transition group-hover:scale-[1.03]"
              data-testid="header-logo-img"
            />
          </a>

          {/* Desktop nav */}
          <nav className="hidden lg:flex items-center gap-8">
            {navItems.map((it) => (
              <a
                key={it.href}
                href={it.href}
                data-testid={`nav-${it.href.replace("#", "")}`}
                className="text-sm font-semibold uppercase tracking-wider text-white/80 hover:text-[#f3bd0e] transition relative group"
              >
                {it.label}
                <span className="absolute left-0 -bottom-1 h-[2px] w-0 bg-[#f3bd0e] group-hover:w-full transition-all duration-300"></span>
              </a>
            ))}
          </nav>

          {/* CTA */}
          <div className="hidden md:flex items-center gap-3">
            <a
              href={telLink(CONTACTS.phones[0].raw)}
              data-testid="header-call-link"
              className="flex items-center gap-2 text-sm font-semibold text-white hover:text-[#f3bd0e] transition"
            >
              <Phone className="w-4 h-4" />
              {CONTACTS.phones[0].label}
            </a>
            <a
              href={waLink(CONTACTS.phones[0].raw)}
              target="_blank"
              rel="noopener noreferrer"
              data-testid="header-whatsapp-cta"
              className="bg-[#f3bd0e] text-black font-bold uppercase tracking-wide text-xs px-5 py-3 rounded-md hover:bg-yellow-300 hover:shadow-[0_0_20px_rgba(243,189,14,0.45)] transition flex items-center gap-2"
            >
              <MessageCircle className="w-4 h-4" />
              WhatsApp
            </a>
          </div>

          {/* Mobile menu button */}
          <button
            onClick={() => setOpen(!open)}
            data-testid="mobile-menu-toggle"
            className="lg:hidden text-white p-2"
            aria-label="Abrir menu"
          >
            {open ? <X className="w-6 h-6" /> : <Menu className="w-6 h-6" />}
          </button>
        </div>

        {/* Mobile menu */}
        {open && (
          <div
            className="lg:hidden border-t border-white/10 py-4 px-2 space-y-2 bg-black/95 backdrop-blur-md rounded-b-md -mx-4 sm:-mx-6 lg:-mx-8 px-4 sm:px-6 lg:px-8"
            data-testid="mobile-menu"
          >
            {navItems.map((it) => (
              <a
                key={it.href}
                href={it.href}
                onClick={() => setOpen(false)}
                className="block px-2 py-2 text-base font-semibold uppercase tracking-wide text-white/90 hover:text-[#f3bd0e]"
                data-testid={`mobile-nav-${it.href.replace("#", "")}`}
              >
                {it.label}
              </a>
            ))}
            <a
              href={waLink(CONTACTS.phones[0].raw)}
              target="_blank"
              rel="noopener noreferrer"
              className="block mt-3 bg-[#f3bd0e] text-black font-bold uppercase text-center px-5 py-3 rounded-md"
              data-testid="mobile-whatsapp-cta"
            >
              Chamar no WhatsApp
            </a>
          </div>
        )}
      </div>
    </header>
  );
}
